module.exports = __webpack_public_path__ + "static/img/background1.510962d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background1.png
// module id = uFI5
// module chunks = 13